import React from "react";
import styled from "@emotion/styled";

const FooterSection = styled.footer`
  background-color: #151418;
  color: #fff;
  padding: 20px;
  text-align: center;
  border-top-left-radius: 50% 20px;
  border-top-right-radius: 50% 20px;
`;

const FooterText = styled.p`
  font-size: 18px;
  margin: 0;
`;

function Footer() {
    return (
        <FooterSection>
            <FooterText>&#169; SurazNepal 2024</FooterText>
            <FooterText>All Rights Reserved.</FooterText>
        </FooterSection>
    );
}

export default Footer;
